import {Locale} from '@aboutyou/config';
import {useLocale} from '@aboutyou/i18n';
import {useScript} from '@aboutyou/ui-components';
import {useEffect} from 'react';
import {SovendusBannerProps} from '../SovendusBanner';

const TRAFFIC_NUMBERS_BY_COUNTRY: Partial<
  Record<Locale, {trafficSourceNumber: number; trafficMediumNumber: number}>
> = {
  [Locale.it_IT]: {
    trafficSourceNumber: 6472,
    trafficMediumNumber: 1,
  },
  [Locale.pl_PL]: {
    trafficSourceNumber: 6471,
    trafficMediumNumber: 1,
  },
  [Locale.de_AT]: {
    trafficSourceNumber: 3374,
    trafficMediumNumber: 4,
  },
  [Locale.de_CH]: {
    trafficSourceNumber: 3375,
    trafficMediumNumber: 4,
  },
  [Locale.fr_CH]: {
    trafficSourceNumber: 3418,
    trafficMediumNumber: 4,
  },
  [Locale.de_DE]: {
    trafficSourceNumber: 1695,
    trafficMediumNumber: 13,
  },
  [Locale.nl_NL]: {
    trafficSourceNumber: 3363,
    trafficMediumNumber: 5,
  },
  [Locale.nl_BE]: {
    trafficSourceNumber: 6578,
    trafficMediumNumber: 1,
  },
  [Locale.fr_BE]: {
    trafficSourceNumber: 6478,
    trafficMediumNumber: 1,
  },
  [Locale.es_ES]: {
    trafficSourceNumber: 6477,
    trafficMediumNumber: 1,
  },
  [Locale.fr_FR]: {
    trafficSourceNumber: 6476,
    trafficMediumNumber: 1,
  },
  [Locale.da_DK]: {
    trafficSourceNumber: 6475,
    trafficMediumNumber: 1,
  },
  [Locale.sv_SE]: {
    trafficSourceNumber: 6474,
    trafficMediumNumber: 1,
  },
  [Locale.fi_FI]: {
    trafficSourceNumber: 7628,
    trafficMediumNumber: 1,
  },
};

export const useSovendusBanner = (props: SovendusBannerProps) => {
  const locale = useLocale();

  const {
    cityName,
    countryCode,
    email,
    firstName,
    lastName,
    orderCurrency,
    orderId,
    salutation,
    sessionId,
    streetName,
    streetNumber,
    usedCouponCode,
    zipCode,
    trafficMediumNumber,
    trafficSourceNumber,
  } = props;

  const sovendusTrafficNumbers =
    trafficMediumNumber && trafficSourceNumber
      ? {
          trafficSourceNumber,
          trafficMediumNumber,
        }
      : TRAFFIC_NUMBERS_BY_COUNTRY[locale]!;

  useEffect(() => {
    window.sovIframes = [
      {
        ...sovendusTrafficNumbers,
        sessionId,
        timestamp: Math.floor(Date.now() / 1000),
        orderId,
        // this field was not agreed upon contract, so we pass 0
        orderValue: 0,
        orderCurrency,
        usedCouponCode: usedCouponCode ?? '',
        iframeContainerId: 'sovendus-container',
        integrationType: 'custom-react',
      },
    ];
    window.sovConsumer = {
      consumerSalutation: salutation ?? '',
      consumerFirstName: firstName ?? '',
      consumerLastName: lastName ?? '',
      consumerEmail: email ?? '',
      consumerCountry: countryCode ?? '',
      consumerZipcode: zipCode ?? '',
      consumerYearOfBirth: 0,
      consumerStreet: streetName ?? '',
      consumerStreetNumber: streetNumber ?? '',
      consumerCity: cityName ?? '',
    };
  }, []);

  const sovendusScriptState = useScript(
    'https://api.sovendus.com/sovabo/common/js/flexibleIframe.js',
    {async: true, id: 'sovendus'},
  );

  return {
    sovendusScriptState,
  };
};
